/** @format */

import {MediaplanFromQuery} from '../models/api';
import {ChartIds} from '../models/chartIds';
import getChartIdByKpiName from './getChartIdByKpiName';

const getAllMediaplanUniqueChartIds = (
  mediaplans: ReadonlyArray<MediaplanFromQuery>,
): ChartIds[] => {
  const allIds = new Set<ChartIds>(['budget']);

  mediaplans.forEach(mediaplan => {
    mediaplan?.kpis?.forEach(d => {
      const id = getChartIdByKpiName(d.name);
      allIds.add(id);
    });
  });

  return Array.from(allIds);
};

export default getAllMediaplanUniqueChartIds;
